<div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 80vh;">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<form #billingForm="ngForm" (ngSubmit)="proceedToPay(billingForm)">
<div *ngIf="!loading">
    <div class="row">
        <div class="col-xl-8">
            <div class="card">
                <div class="card-body checkout-tab">
                <div>
                    <h4 class="mb-1">Contact Information</h4>
                    <p class="text-muted mb-3">&nbsp;</p>
                </div>
                <div>
                    <div class="row">
                    <div class="col-sm-6">
                        <div class="mb-3">
                        <label for="billinginfo-email" class="form-label fw-semibold">Email Address</label>
                        <input type="email" class="form-control" id="billinginfo-email" [(ngModel)]="customerDetails.EMAIL_ID" name="email" readonly />
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-6">
                        <div class="mb-3">
                        <label for="billinginfo-phone" class="form-label">Phone Number</label>
                        <input type="text" class="form-control" id="billinginfo-phone" [(ngModel)]="customerDetails.MOBILE_NO" name="mobilenumber" readonly />
                        </div>
                    </div>
                    </div>
                    <hr>
                    <div>
                    <h4 class="mb-1">Shipping Address</h4>
                    <p class="text-muted mb-2">&nbsp;</p>
                    </div>
                    <div class="row">
                    <div class="col-sm-6">
                        <div class="mb-3">
                        <label for="billinginfo-firstName" class="form-label fw-semibold">First Name</label>
                        <!-- <input type="text" class="form-control" id="billinginfo-firstName" [(ngModel)]="billingInfo.first_name" placeholder="Enter first name" /> -->
                         <input
                            type="text"
                            class="form-control"
                            id="billinginfo-firstName"
                            [(ngModel)]="billingInfo.first_name"
                            name="first_name"
                            placeholder="Enter first name"
                            required
                            />
                            <div *ngIf="billingForm.submitted && !billingInfo.first_name" class="text-danger mt-1">
                            First Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="mb-3">
                        <label for="billinginfo-lastName" class="form-label fw-semibold">Last Name</label>
                        <!-- <input type="text" class="form-control" id="billinginfo-lastName" [(ngModel)]="billingInfo.last_name" placeholder="Enter last name" /> -->
                        <input
                            type="text"
                            class="form-control"
                            id="billinginfo-lastName"
                            [(ngModel)]="billingInfo.last_name"
                            name="last_name"
                            placeholder="Enter last name"
                            required
                            />
                            <div *ngIf="billingForm.submitted && !billingInfo.last_name" class="text-danger mt-1">
                            Last Name is required.
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-6">
                        <div class="mb-3">
                        <label for="billinginfo-phone" class="form-label fw-semibold">Phone</label>
                        <!-- <input type="text" class="form-control" [(ngModel)]="billingInfo.phone" placeholder="phone number" /> -->
                            <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="billingInfo.phone"
                                name="phone"
                                pattern="^[6-9][0-9]{9}$"
                                required
                                placeholder="Phone number"
                                />
                                <div *ngIf="billingForm.submitted && (billingForm.controls['phone']?.invalid)" class="text-danger mt-1">
                                Valid 10-digit phone number is required.
                                </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                        <label for="zip" class="form-label fw-semibold">Pin Code</label>
                        <!-- <input type="text" class="form-control" id="zip" [(ngModel)]="billingInfo.pincode" placeholder="Enter zip code" /> -->
                         <input
                            type="text"
                            class="form-control"
                            id="zip"
                            [(ngModel)]="billingInfo.pincode"
                            name="pincode"
                            pattern="^[0-9]{6}$"
                            required
                            placeholder="Enter zip code"
                            />
                            <div *ngIf="billingForm.submitted && billingForm.controls['pincode']?.invalid" class="text-danger mt-1">
                            Valid 6-digit pincode is required.
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                            <label for="billinginfo-city" class="form-label fw-semibold">City</label>
                            <!-- <input type="text" class="form-control" id="billinginfo-city" [(ngModel)]="billingInfo.city" placeholder="Enter City" /> -->
                                <input
                                    type="text"
                                    class="form-control"
                                    id="billinginfo-city"
                                    [(ngModel)]="billingInfo.city"
                                    name="city"
                                    placeholder="Enter city"
                                    required
                                    />
                                    <div *ngIf="billingForm.submitted && !billingInfo.city" class="text-danger mt-1">
                                    City Name is required.
                                    </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label for="state" class="form-label fw-semibold">State</label>
                                <select
                                class="form-select"
                                id="state"
                                [(ngModel)]="billingInfo.state"
                                name="state"
                                required
                                #stateRef="ngModel"
                                >
                                <option value="">Select State...</option>
                                <option value="Andhra Pradesh">Andhra Pradesh</option>
                                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                <option value="Assam">Assam</option>
                                <option value="Bihar">Bihar</option>
                                <option value="Chhattisgarh">Chhattisgarh</option>
                                <option value="Goa">Goa</option>
                                <option value="Gujarat">Gujarat</option>
                                <option value="Haryana">Haryana</option>
                                <option value="Himachal Pradesh">Himachal Pradesh</option>
                                <option value="Jharkhand">Jharkhand</option>
                                <option value="Karnataka">Karnataka</option>
                                <option value="Kerala">Kerala</option>
                                <option value="Madhya Pradesh">Madhya Pradesh</option>
                                <option value="Maharashtra">Maharashtra</option>
                                <option value="Manipur">Manipur</option>
                                <option value="Meghalaya">Meghalaya</option>
                                <option value="Mizoram">Mizoram</option>
                                <option value="Nagaland">Nagaland</option>
                                <option value="Odisha">Odisha</option>
                                <option value="Punjab">Punjab</option>
                                <option value="Rajasthan">Rajasthan</option>
                                <option value="Sikkim">Sikkim</option>
                                <option value="Tamil Nadu">Tamil Nadu</option>
                                <option value="Telangana">Telangana</option>
                                <option value="Tripura">Tripura</option>
                                <option value="Uttar Pradesh">Uttar Pradesh</option>
                                <option value="Uttarakhand">Uttarakhand</option>
                                <option value="West Bengal">West Bengal</option>
                                <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                                <option value="Chandigarh">Chandigarh</option>
                                <option value="Dadra and Nagar Haveli and Daman and Diu">Dadra and Nagar Haveli and Daman and Diu</option>
                                <option value="Delhi">Delhi</option>
                                <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                                <option value="Ladakh">Ladakh</option>
                                <option value="Lakshadweep">Lakshadweep</option>
                                <option value="Puducherry">Puducherry</option>
                                </select>

                                <div
                                *ngIf="billingForm.submitted && stateRef.invalid"
                                class="text-danger mt-1"
                                >
                                State is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                            <label for="billinginfo-address" class="form-label fw-semibold">Flat, House no, Building, Company, Apartments</label>
                            <!-- <input type="text" class="form-control" id="billinginfo-address" [(ngModel)]="billingInfo.address1" placeholder="Flat, House no, Building, Company, Apartments" /> -->
                                <input
                                    type="text"
                                    class="form-control"
                                    id="billinginfo-address"
                                    [(ngModel)]="billingInfo.address1"
                                    name="address1"
                                    placeholder="Enter Address Line 1"
                                    required
                                    />
                                    <div *ngIf="billingForm.submitted && !billingInfo.address1" class="text-danger mt-1">
                                    Address Line 1 is required.
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-12">
                        <div class="mb-3">
                        <label for="billinginfo-address1" class="form-label fw-semibold">Area, Street, Sector, Village</label>
                        <!-- <input type="text" class="form-control" id="billinginfo-address1" [(ngModel)]="billingInfo.address2" placeholder="Area, Street, Sector, Village" /> -->
                            <input
                                type="text"
                                class="form-control"
                                id="billinginfo-address1"
                                [(ngModel)]="billingInfo.address2"
                                name="address2"
                                placeholder="Enter Address Line 1"
                                required
                                />
                                <div *ngIf="billingForm.submitted && !billingInfo.address2" class="text-danger mt-1">
                                Address Line 2 is required.
                                </div>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-12">
                        <div class="mb-3">
                        <label for="billinginfo-landmark" class="form-label fw-semibold">Landmark (Optional)</label>
                        <!-- <input type="text" class="form-control" id="billinginfo-landmark" [(ngModel)]="billingInfo.landmark" placeholder="Landmark (Optional)" /> -->
                            <input
                                type="text"
                                class="form-control"
                                id="billinginfo-landmark"
                                [(ngModel)]="billingInfo.landmark"
                                name="landmark"
                                placeholder="Enter Landmark"
                                />
                                <!-- <div *ngIf="billingForm.submitted && !billingInfo.landmark" class="text-danger mt-1">
                                Address Line 2 is required.
                                </div> -->
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- end col -->

        <div class="col-xl-4">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive table-card">
                        <table class="table table-borderless align-middle mb-0" style="background: aliceblue;border-radius: 22px;">
                            <tbody>
                                <tr>
                                    <td style="width: 99px;">
                                        <div class="avatar-md bg-light rounded p-1">
                                        <img
                                            *ngIf="productDetails?.skuName"
                                            [src]="'https://images.lakeeshop.com/Images/' + productDetails.skuName + '.jpg'"
                                            alt="{{ productDetails.name || 'Product Image' }}"
                                            class="img-fluid d-block"
                                        />
                                        </div>
                                    </td>
                                    <td>
                                        <h5 class="fs-14"><a routerLink="/ecommerce/product-detail/1"
                                                class="text-body">{{ productDetails?.name }}</a>
                                        </h5>
                                        <p class="text-muted mb-0">{{ productDetails?.category }}</p>
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <div class="card-body" style="border: 1px solid #e5e5e5;border-radius: 20px;overflow: hidden;margin-top: 13px;">
                    <div class="table-responsive table-card">
                        <table class="table table-borderless align-middle mb-3 mt-3 mr-3 ml-3">
                            <tbody>
                                <tr>
                                    <td class="fw-semibold" colspan="2">Order Details</td>
                                    <td class="fw-semibold text-end">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><span class="text-muted">Total MRP ({{ productDetails?.quantity }} Items)</span></td>
                                    <td class="fw-semibold text-end">Rs {{ productDetails?.productPrice }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><span class="text-muted">Discount on MRP</span></td>
                                    <td class="text-end" style="color: #008000">- Rs {{ productDetails?.discountAmount }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><span class="text-muted">Shipping</span></td>
                                    <td class="text-end">Rs 0</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><span class="text-muted">Convenience Fee</span></td>
                                    <td class="text-end">Rs {{ productDetails?.cfee }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-semibold" colspan="2">Total Amount</td>
                                    <td class="fw-semibold text-end">Rs {{ productDetails?.total }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <div style="width: 100%; margin: 0 auto; border-bottom: 1px solid #e5e5e5;"></div>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="2">Discount <span class="text-muted">(VELZON15)</span> : </td>
                                    <td class="text-end">- $ 50.00</td>
                                </tr> -->
                                <tr>
                                    <td colspan="2">{{ orderDetails?.currencyName }}s Used</td>
                                    <td class="fw-semibold text-end">{{ orderDetails?.pointUsed }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <div style="width: 100%; margin: 0 auto; border-bottom: 1px solid #e5e5e5;"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th colspan="2">Total Cash Amount Payable</th>
                                    <td class="text-end">
                                        <span class="fw-semibold">
                                        <!-- Rs {{ (productDetails?.total || 0) - (orderDetails?.pointUsed || 0) }} -->
                                         Rs {{ orderDetails?.amountUsed}}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <div style="width: 100%; margin: 0 auto; border-bottom: 1px solid #e5e5e5;"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" style="text-align: center;">
                                        <button
                                        type="submit"
                                        class="btn btn-primary ms-auto"
                                        style="width: 100%; border-radius: 40px;"
                                        [disabled]="otpSubmitting"
                                        >
                                        <span *ngIf="!otpSubmitting">Proceed to Pay</span>
                                        <span *ngIf="otpSubmitting">
                                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Processing...
                                        </span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end row -->
</div>
</form>
<!-- editItemModal -->
<ng-template #content role="document" let-modal style="border-radius: 34px;">
    <div class="modal-header" style="text-align: center;">
        <button type="button" class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="modal.dismiss('Cross click'); clearOtpTimer(); resetOtpData()">
        </button>
    </div>
    <div class="modal-body">
        <div>
        <div class="mb-3">
            <h5 class="modal-title" id="addAddressModalLabel" style="text-align: center;font-weight: 700;">Enter OTP</h5>
        </div>
        <div class="">
            <p class="text-muted" style="TEXT-ALIGN: center;padding: 4px 20px;margin-bottom: 45px;">
            Please enter the OTP sent on your registered email ID and mobile number
            </p>
        </div>

        <!-- OTP Input with validation -->
        <div class="mb-3 text-center">
            <input
                type="password"
                class="form-control text-center"
                id="addaddress-Name"
                [(ngModel)]="otpCode"
                placeholder="Enter OTP"
                maxlength="6"
                inputmode="numeric"
                pattern="[0-9]*"
                style="font-size: 1.5rem; letter-spacing: 8px;"
            />
            <div *ngIf="otpError" class="text-danger mt-2">
                {{ otpError }}
            </div>
        </div>

        <!-- Timer / Resend link -->
        <div class="mb-0 text-center">
            <h6 *ngIf="!resendEnabled">
            00:{{ otpTimer < 10 ? '0' + otpTimer : otpTimer }}
            <span class="text-muted">Resend OTP</span>
            </h6>
            <h6 *ngIf="resendEnabled">
            <a href="javascript:void(0);" (click)="resendOtpOnly()">Resend OTP</a>
            </h6>
        </div>
        </div>
    </div>

    <!-- Submit Button with loader -->
    <div class="modal-footer">
        <button type="button"
                class="btn btn-primary ms-auto"
                style="width: 100%; border-radius: 40px;"
                (click)="submitOtp(modal)"
                [disabled]="otpSubmitting">
        {{ otpSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
    </div>
</ng-template>



<!-- removeItemModal -->
<ng-template #deleteModel let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close"
                (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop"
                    colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
                <div class="mt-4 pt-2 fs-14 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p class="text-muted mx-4 mb-0">Are you sure you want to remove this address ?</p>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal"
                    (click)="modal.close('Close click')">Close</button>
                <button type="button" class="btn w-sm btn-danger " id="delete-product">Yes, Delete It!</button>
            </div>
        </div>
    </div><!-- /.modal-content -->
</ng-template>


<ng-template #errorModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Failed</h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body text-center">
      <p class="text-danger">Failed to send OTP. Please try again.</p>
    </div>
  </div>
</ng-template>